"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Cross = void 0;
var react_1 = __importDefault(require("react"));
exports.Cross = function (props) {
    var cx = props.cx, cy = props.cy, stroke = props.stroke;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("svg", __assign({ x: cx - 17, y: cy - 17, width: 550, height: 550 }, { fill: stroke, opacity: 0.3 }, { viewBox: '0 0 1024 1024', className: 'hover-shape' }),
            react_1.default.createElement(CrossSvgPath, null)),
        react_1.default.createElement("svg", __assign({ x: cx - 10, y: cy - 10, width: 315, height: 315 }, { fill: stroke }, { viewBox: '0 0 1024 1024' }),
            react_1.default.createElement(CrossSvgPath, null))));
};
var CrossSvgPath = function () { return (react_1.default.createElement("path", { d: 'M40 12 L26 12 L26 24 L14 24 L14 38 L26 38 L26 50 L40 50 L40 38 L52 38 L52 24 L40 24 Z' })); };
//# sourceMappingURL=Cross.js.map